// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__1L7l_","title":"AfterBackImages_title__3NFWz","images":"AfterBackImages_images__evBHD"};